import type { TransactionRow } from '../types';
import { fmtMoney, fmtShortDate } from '../lib/format';

export function TransactionsTable({ rows }: { rows: TransactionRow[] }) {
  if (rows.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-5">
        <div className="text-sm text-slate-500 py-4">No transactions in this range.</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50">
          <tr className="text-left text-slate-500 text-xs uppercase tracking-wide">
            <th className="px-4 py-2.5">Date</th>
            <th className="px-4 py-2.5">Merchant</th>
            <th className="px-4 py-2.5">Account</th>
            <th className="px-4 py-2.5">Category</th>
            <th className="px-4 py-2.5 text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50">
              <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{fmtShortDate(r.occurred_at)}</td>
              <td className="px-4 py-2.5 font-medium truncate max-w-[240px]">
                {r.merchant ?? r.description ?? '—'}
                {r.is_flagged ? <span className="ml-2 text-xs px-1.5 py-0.5 rounded bg-amber-100 text-amber-900">flagged</span> : null}
              </td>
              <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{r.account_name}</td>
              <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{r.category_name}</td>
              <td className={`px-4 py-2.5 text-right tnum font-semibold whitespace-nowrap ${r.amount_cents < 0 ? 'text-rose-700' : 'text-emerald-700'}`}>
                {fmtMoney(r.amount_cents, { sign: true })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
